// JavaScript Document
// Set a few variables at the start for global scope
var myCanvas = document.getElementById("Canvas1");
var context = myCanvas.getContext("2d");
var mouseX = 450;
var mouseY = 0;
var isMoving = true;
// Add event listener which activates when the mouse moves in the canvas
myCanvas.addEventListener("mousemove", onMove, false);
// Add an event listener to toggle the other event listener when the mouse clicks
myCanvas.addEventListener("click", function() {
    if (isMoving === true) {
        myCanvas.removeEventListener("mousemove", onMove);
        isMoving = false;
    } else {
        myCanvas.addEventListener("mousemove", onMove, false);
        isMoving = true;
    }
});
onSelect(1);
onSelect(2);
// Calculate the values, then draw the lines and start the update() loop thing
var values = calcValues();
otherLines(values);
update();
function otherLines(values) {
    // Draw the reflection line
    context.beginPath();
    context.moveTo(myCanvas.width - mouseX, mouseY);
    context.lineTo(myCanvas.width / 2, myCanvas.height / 2);
    context.closePath();
    context.lineWidth = 5;
    context.strokeStyle = "#ffff80";
    context.setLineDash([]);
    context.stroke();
    // Draw the refraction line
    context.beginPath();
    context.moveTo((mouseX > myCanvas.width / 2 ? mouseY > myCanvas.height / 2 ? -1 : 1 : mouseY > myCanvas.height / 2 ? -1 : 1) * (values.lengthI * (Math.sin(values.thetaR) * 180) / Math.PI) + myCanvas.width / 2, (mouseY > myCanvas.height / 2 ? -1 : 1) * (values.lengthI * (Math.cos(values.thetaR) * 180) / Math.PI) + myCanvas.height / 2);
    context.lineTo(myCanvas.width / 2, myCanvas.height / 2);
    context.closePath();
    context.lineWidth = 5;
    context.strokeStyle = "#00f";
    context.setLineDash([]);
    context.stroke();
    // Draw the incident angle arc
    context.beginPath();
    context.arc(myCanvas.width / 2, myCanvas.height / 2, values.lengthI / 8, mouseY > myCanvas.height / 2 ? Math.PI * .5 : Math.PI * 1.5, mouseY <= myCanvas.height / 2 ? Math.PI * 1.5 - values.thetaI : Math.PI * .5 - values.thetaI, values.thetaI >= 0 ? true : false);
    context.lineWidth = 2;
    context.strokeStyle = "#f00";
    context.setLineDash([]);
    context.stroke();
    // Draw the reflection angle arc
    context.beginPath();
    context.arc(myCanvas.width / 2, myCanvas.height / 2, values.lengthI / 8, mouseY > myCanvas.height / 2 ? Math.PI * .5 : Math.PI * 1.5, mouseY <= myCanvas.height / 2 ? Math.PI * 1.5 + values.thetaI : Math.PI * .5 + values.thetaI, values.thetaI >= 0 ? false : true);
    context.lineWidth = 2;
    context.strokeStyle = "#f90";
    context.setLineDash([]);
    context.stroke();
    // Draw the refraction angle arc
    context.beginPath();
    context.arc(myCanvas.width / 2, myCanvas.height / 2, values.lengthI / 8, mouseY > myCanvas.height / 2 ? Math.PI * 1.5 : Math.PI * .5, (mouseY <= myCanvas.height / 2 ? Math.PI * 1.5 - values.thetaR : mouseX <= myCanvas.width / 2 ? Math.PI * .5 - values.thetaR : 2.5 * Math.PI - values.thetaR) - Math.PI, values.thetaR > 0 ? true : false);
    context.lineWidth = 2;
    context.strokeStyle = "#393";
    context.setLineDash([]);
    context.stroke();
    // Draw the horizontal line down the center to seperate the two materials
    context.beginPath();
    context.moveTo(0, myCanvas.height / 2);
    context.lineTo(myCanvas.width, myCanvas.height / 2);
    context.lineWidth = 3;
    context.strokeStyle = "grey";
    context.setLineDash([]);
    context.stroke();
    // Draw the normal line perpendicular to the center
    context.beginPath();
    context.moveTo(myCanvas.width / 2, 0);
    context.lineTo(myCanvas.width / 2, myCanvas.width);
    context.lineWidth = 1;
    context.strokeStyle = "grey";
    context.setLineDash([
        5,
        15
    ]);
    context.stroke();
}
function writeText(values) {
    // Write the material for the top layer
    var mat1_obj = document.getElementById("M1");
    var mat1 = mat1_obj.options[mat1_obj.selectedIndex].text;
    context.font = "18px Arial";
    context.fillStyle = "black";
    context.textAlign = "right";
    context.fillText(mat1, myCanvas.width - 5, myCanvas.height / 2 - 30);
    // Write the index of refraction for the top layer
    var n1_obj = document.getElementById("N1");
    var n1 = n1_obj.value;
    context.font = "18px Arial";
    context.fillStyle = "black";
    context.textAlign = "right";
    context.fillText("n = " + n1, myCanvas.width - 5, myCanvas.height / 2 - 10);
    // Write the material for the bottom layer
    var mat2_obj = document.getElementById("M2");
    var mat2 = mat2_obj.options[mat2_obj.selectedIndex].text;
    context.font = "18px Arial";
    context.fillStyle = "black";
    context.textAlign = "left";
    context.fillText(mat2, 5, myCanvas.height / 2 + 20);
    // Write the index of refraction for the bottom layer
    var n2_obj = document.getElementById("N2");
    var n2 = n2_obj.value;
    context.font = "18px Arial";
    context.fillStyle = "black";
    context.textAlign = "left";
    context.fillText("n = " + n2, 5, myCanvas.height / 2 + 40);
    // Write the critical angle
    context.font = "18px Arial";
    context.fillStyle = "black";
    if (n1 >= n2) {
        // If the critical angle is on top, write it in the upper half
        context.textAlign = "left";
        context.fillText('\u03B8       = ' + (values.thetaC * 180 / Math.PI).toFixed(3) + '\u00BA', 5, 20);
        // Write the "critical" subscript seperately
        context.font = "10px Arial";
        context.fillText('critical', 15, 20);
    } else {
        // If the critical angle is on the bottom, write it in the lower half
        context.textAlign = "left";
        context.fillText('\u03B8       = ' + (values.thetaC * 180 / Math.PI).toFixed(3) + '\u00BA', 5, myCanvas.height - 10);
        // Write the "critical" subscript seperately
        context.font = "10px Arial";
        context.fillText('critical', 15, myCanvas.height - 10);
    }
}
function calcValues() {
    // Fetch the values required for calculation
    var n1_obj = document.getElementById("N1");
    var n1 = n1_obj.value;
    var n2_obj = document.getElementById("N2");
    var n2 = n2_obj.value;
    var incAngle = Math.atan((myCanvas.width / 2 - mouseX) / (myCanvas.height / 2 - mouseY));
    return {
        // Return the incident angle
        thetaI: incAngle,
        // Return the length of the incident ray
        lengthI: Math.sqrt(Math.pow(mouseX - myCanvas.width / 2, 2) + Math.pow(mouseY - myCanvas.height / 2, 2)),
        // Return the refraction angle
        thetaR: Math.asin(Math.sin(incAngle) / (mouseY < myCanvas.height / 2 ? n2 / n1 : n1 / n2)),
        // Return the critical angle
        thetaC: Math.asin(n1 >= n2 ? n2 / n1 : n1 / n2)
    };
}
function updateAngles(values) {
    // Update the input (text) box for the incident angle
    var texti = document.getElementById("Ai");
    var vali = Math.abs(values.thetaI * 180 / Math.PI);
    texti.value = vali.toFixed(3) + '\u00BA';
    // Update the input (text) box for the refracted angle
    var textr = document.getElementById("Ar");
    var valr = Math.abs(values.thetaR * 180 / Math.PI);
    if (isNaN(valr)) textr.value = "ERROR";
    else textr.value = valr.toFixed(3) + '\u00BA';
}
function update() {
    // Clear the canvas, then redraw everything
    context.clearRect(0, 0, myCanvas.width, myCanvas.height);
    // Draw the incident ray
    context.beginPath();
    context.moveTo(mouseX, mouseY);
    context.lineTo(myCanvas.width / 2, myCanvas.height / 2);
    context.closePath();
    context.lineWidth = 5;
    context.strokeStyle = "#ffff80";
    context.setLineDash([]);
    context.stroke();
    // Recalculate all of the values
    values = calcValues();
    // Use the values to re-draw everything on the canvas
    updateAngles(values);
    otherLines(values);
    writeText(values);
    // Basically just looping this function
    requestAnimationFrame(update);
}
function onMove(e) {
    // Create a variable to store the x and y coordinates
    var canvasPos = getPos(myCanvas, e);
    mouseX = canvasPos.x;
    mouseY = canvasPos.y;
}
function getPos(myCanvas, e) {
    // Store a property of the canvas in a variable
    var canvasRect = myCanvas.getBoundingClientRect();
    // Return the mouse's coordinates on the canvas
    return {
        x: (e.clientX - canvasRect.left) / (canvasRect.right - canvasRect.left) * myCanvas.width,
        y: (e.clientY - canvasRect.top) / (canvasRect.bottom - canvasRect.top) * myCanvas.height
    };
}
// Runs at the start, and every time a new material is selected
function onSelect(x) {
    // Declare variables for HTML elements
    var textbox = document.getElementById("N" + x);
    var selectbox = document.getElementById("M" + x);
    var newN = selectbox.value;
    if (newN < 0) {
        // If the custom value was selected, clear the text box and allow editing
        textbox.value = "";
        textbox.readOnly = false;
    } else {
        // If a pre-existing option was chosen, update the index of refraction
        textbox.readOnly = true;
        textbox.value = newN;
    }
    // Re-calculate the values, then re-write the numbers on the canvas
    values = calcValues();
    writeText(values);
}

//# sourceMappingURL=snells_law.c84eb0a2.js.map
